export enum ErrorType{
  ERROR_SERVER,
  ERROR_PERMISSION
}